module.exports = __webpack_public_path__ + "static/media/live.35d2222c.svg";